var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5338,
    cy: 11.5338,
    r: 11.5338,
    fill: "#1A47B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5994 6.91627C21.95 5.42238 20.9949 4.09025 19.8124 2.99764L11.9175 8.50005L3.95798 2.88352C2.69497 4.01725 1.68151 5.42008 1.00928 7.00097L7.49626 11.5814L1.02308 16.0929C1.66068 17.5797 2.60048 18.908 3.76588 20.0017C6.19973 18.2699 8.91698 16.3657 11.615 14.4896L19.6801 20.1843C20.9458 19.05 21.9614 17.6457 22.6349 16.0627L16.051 11.4168C18.485 9.73668 20.7522 8.18059 22.5994 6.91627Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.87527 3.89276L11.9071 10.3307L20.3753 4.30917C20.8831 4.9294 21.3275 5.60351 21.6987 6.3216L13.9916 11.8165L21.5396 17.1968C21.1423 17.9132 20.6709 18.5828 20.1359 19.1953L11.8888 13.3157L3.10615 19.5775C2.54483 18.99 2.04496 18.3433 1.61684 17.6478L9.80166 11.8278L1.44178 5.86778C1.8498 5.15851 2.33107 4.49673 2.87527 3.89276Z",
    fill: "#F93939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.876646 7.11531H7.40609V0.760583C8.6877 0.269234 10.0793 0 11.5338 0C12.9977 0 14.3979 0.272725 15.6864 0.770137V7.11531H22.191C22.7558 8.47618 23.0676 9.96859 23.0676 11.5338C23.0676 13.0972 22.7566 14.588 22.1929 15.9476H15.6864V22.2975C14.4018 22.7934 13.0063 23.066 11.5472 23.0676H11.5204C10.0708 23.066 8.68376 22.7969 7.40609 22.307V15.9476H0.874694C0.31107 14.588 0 13.0972 0 11.5338C0 9.96859 0.311788 8.47618 0.876646 7.11531Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.308632 8.87216H9.14341V0.248022C9.91463 0.0854838 10.7142 0 11.5338 0C12.3533 0 13.1528 0.0854578 13.9239 0.247947V8.87216H22.759C22.9608 9.72659 23.0676 10.6177 23.0676 11.5338C23.0676 12.4499 22.9608 13.341 22.759 14.1955H13.9239V22.8197C13.157 22.9813 12.362 23.0667 11.5472 23.0676H11.5204C10.7055 23.0667 9.91042 22.9813 9.14341 22.8196V14.1955H0.308629C0.1068 13.341 0 12.4499 0 11.5338C0 10.6177 0.106801 9.72659 0.308632 8.87216Z",
    fill: "#F93939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.9caf7c075595e77f02b77074ea67c1ec.svg";
export { ForwardRef as ReactComponent };